<template>
  <div class="overlay js-overlay">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Overlay',
};
</script>

<style lang="scss">
  @import '@/scss/components/ui/overlay.scss';
</style>
